var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social"},_vm._l((_vm.socialList),function(link,idx){return _c('a',{key:idx,staticClass:"social__links",attrs:{"href":link.href}},[_c('VIconMTS',{staticClass:"social__links-icon",attrs:{"name":link.icon,"width":_vm.icon.width,"height":_vm.icon.height,"fill":_vm.icon.color}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }